import FabricAnalyticsListeners, {
  type AnalyticsWebClient
} from '@atlaskit/analytics-listeners';
import { FlagsProvider } from '@atlaskit/flag';
import { ConversationAssistantBlankObjectExperience } from '@atlassian/conversation-assistant-blank-object-experience/conversation-assistant-blank-object-experience';
import { useAnalytics } from '@databases/analytics';
import { getCloudId } from '@databases/database-state';
import usePanel from '@databases/panel/usePanel';
import React from 'react';
import { IntlProvider, useIntl } from 'react-intl-next';

import { useDatabaseSmartPrompts } from '../blank-object-experience-smart-prompts/useDatabaseSmartPrompts';

import { messages } from './messages';
import { useDatabaseBlankObjectSubmit } from './useDatabaseBlankObjectSubmit';

interface DatabaseBlankObjectExperienceProps {
  contentId: string;
  onSubmit?: () => void;
}

export const DatabaseBlankObjectExperience = ({
  contentId,
  onSubmit
}: DatabaseBlankObjectExperienceProps) => {
  const { formatMessage, locale } = useIntl();
  const { showPanel } = usePanel();
  const siteId = getCloudId() ?? '';

  const analyticsClient = useAnalytics();
  const analyticsWebClient = analyticsClient?.client as AnalyticsWebClient | undefined;
  const handleSubmit = useDatabaseBlankObjectSubmit({ contentId, onSubmit });
  const { smartPrompts, resolvePersonalizedPromptIcon } = useDatabaseSmartPrompts();
  const handleOpenTemplates = () => {
    showPanel('DatabaseSetupPanel', { initialTab: 'templates' });
  };

  return (
    <IntlProvider locale={locale}>
      <FabricAnalyticsListeners client={analyticsWebClient}>
        <FlagsProvider>
          <ConversationAssistantBlankObjectExperience
            testId="database-blank-object-experience"
            siteId={siteId}
            promptDraftAndModeKey={contentId}
            contentType="database"
            smartPrompts={smartPrompts}
            enablePersonalizedPrompts
            resolvePersonalizedPromptIcon={resolvePersonalizedPromptIcon}
            smartPromptsPosition="above"
            onSubmit={handleSubmit}
            shouldExpandWidth
            shouldRenderQuickActionsInPortal={false}
            moreButtonOverride={{
              label: formatMessage(
                messages['database-blank-object-experience.templates-button']
              ),
              onClick: handleOpenTemplates
            }}
          />
        </FlagsProvider>
      </FabricAnalyticsListeners>
    </IntlProvider>
  );
};
